import { track } from '@/features/tracking';
import type { TrackContextPayload } from '@/features/tracking';

type ChatbotEventName =
  | 'chatbot_open'
  | 'chatbot_quick_action'
  | 'chatbot_user_message'
  | 'chatbot_idle_reset'
  | 'chatbot_booking_started'
  | 'chatbot_escalated';

const IMPRESSION_EVENTS = new Set<ChatbotEventName>([
  'chatbot_open',
  'chatbot_idle_reset',
]);

export function trackChatbotEvent(
  eventName: ChatbotEventName,
  payload: TrackContextPayload = {}
) {
  track({
    event: IMPRESSION_EVENTS.has(eventName) ? 'impression' : 'click',
    eventAction: eventName,
    eventCategory: 'chatbot',
    eventDescription: eventName,
    screenName: 'websiteChatbotPage',
    payload,
  });
}
